import { EmptyState } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

export const SkillsPage = () => {
  const m = useMessages(messages)
  return (
    <div className="container mx-auto px-6 py-8 max-w-7xl">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">{m.title}</h1>
        <p className="text-sm text-muted-foreground mt-1">{m.subtitle}</p>
      </div>
      {/* Маскот по центру свободной области — как пустые «Мои курсы» и 404. */}
      <div className="flex min-h-[calc(100dvh-10rem)] items-center justify-center">
        <EmptyState className="py-0" title={m.comingSoon} />
      </div>
    </div>
  )
}
